import {Box, Button, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import React from 'react';

import {RatingStatusEnum} from 'domain/usecases';
import Image from 'presentation/assets/images/lifestyle-support.svg';
import {Loading} from 'presentation/components/Loading/Loading';
import {OperationStateTypesEnum} from 'presentation/constants';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';

import {ImageContainer, StyledDialog, StyledDialogHeader} from './styles';
import {ErrorEvaluatingProps} from './types';
import {useRatingFormDataStore} from '../../stores/useRatingFormDataStore';
import {useRatingStars} from '../../hooks/useRatingStars';

const {pleaseTryAgain, tryAgain, notPossibleAction} = translations['pt-br'].commons;
const {rateYourAttendance} = translations['pt-br'].privateFlow.fiveStarsRating;

export function ErrorEvaluating({ratingDetail}: ErrorEvaluatingProps) {
	const {handleSubmitEvaluation, operationState} = useRatingStars({ratingDetail});
	const ratingFormData = useRatingFormDataStore(state => state.ratingFormData);

	const data = {
		items: ratingFormData.map(item => ({
			...item,
			status: RatingStatusEnum.EVALUATED,
			avaliacao: JSON.stringify(item.avaliacao),
		})),
	};

	const isSubmitting = operationState === OperationStateTypesEnum.SUBMITTING;

	return (
		<StyledDialog open={true}>
			<StyledDialogHeader>{rateYourAttendance}</StyledDialogHeader>
			<DialogContent>
				<ImageContainer>
					<img
						src={Image}
						alt="Uma pessoa segura um guarda-chuva vermelho e amarelo sobre outra pessoa, protegendo-a de uma nuvem escura com chuva e relâmpagos."
						width={140}
						height={140}
					/>
				</ImageContainer>
				<DialogTitle textAlign="center">{notPossibleAction}</DialogTitle>
				<DialogContentText textAlign="center" color="text.primary">
					{pleaseTryAgain}
				</DialogContentText>
			</DialogContent>
			<Box p={2}>
				<Button
					fullWidth
					size="large"
					variant="outlined"
					disabled={isSubmitting}
					onClick={() => handleSubmitEvaluation(data)}
					endIcon={
						isSubmitting ? (
							<Loading size={20} color="inherit" />
						) : (
							<Icon name="reload" size={24} color="inherit" />
						)
					}>
					{tryAgain}
				</Button>
			</Box>
		</StyledDialog>
	);
}
